<div class="vtz-decline-contest"role="dialog"  >
    <label aria-hidden="true" id = "dialog" class="visuallyhidden" i18n>Dialog</label>
<img alt="" src="/assets/images/logo.svg" />
<h2 id="dialog1Title" mat-dialog-title i18n>Decline to vote for {{data.contest}}</h2>
<mat-dialog-content   >
    <p id ="dialogDescription1">{{data.dialogP1}}</p>
    <p id ="dialogDescription2">{{data.dialogP2}}</p>
    <p id ="dialogDescription3" i18n >Select 'BACK' to cancel or 'CONFIRM' to agree.</p>
    </mat-dialog-content>
<mat-dialog-actions align="center">
    <button 
    aria-describedby="dialogDescription3" 
    style="margin-right:20px;" class="button-decline" mat-dialog-close i18n>Back</button>
    <button 
    aria-describedby=" dialog dialog1Title dialogDescription1 dialogDescription2 dialogDescription3" 
    class="button-decline" [mat-dialog-close]="true" cdkFocusInitial i18n>CONFIRM</button>
</mat-dialog-actions>

</div>
<app-back-button-confirmation-modal>
</app-back-button-confirmation-modal>